/* External dependencies */
import { gql } from '@apollo/client';

export const createOrderMutation = gql`
  mutation createOrder($input: CreateOrderInput!) {
    createOrder(input: $input) {
      id
      name
      trackingNumber
      parcelCount
      status
      deliveryAddress {
        address
      }
      createdDate
      user {
        id
      }
    }
  }
`;
